"use strict";

exports.__esModule = true;
var _MasterDetailView = require("./MasterDetailView");
Object.keys(_MasterDetailView).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MasterDetailView[key]) return;
  exports[key] = _MasterDetailView[key];
});